const NotFound = () => {
  return (<>Not found page</>);
};

export default NotFound;
